import { Sprite } from "@pixi/react";
import React from "react";

export enum CounterDisplayType {
  NotDisplayed,
  DisplayedOnTop,
  DisplayedOnBottom
}

export function getCheckerPositions(
  area: [number, number, number, number],
  count: number,
  textureHeight: number,
  fromTop: boolean = true
): { x: number; y: number }[] {
  const [x, y, width, height] = area;
  let spacing = height / (count + 1);
  let offset = textureHeight / 2 - spacing;
  spacing = (height - offset * 2) / (count + 1);
  if (spacing > textureHeight) spacing = textureHeight;
  offset = fromTop ? textureHeight / 2 - spacing : height - spacing * count - textureHeight / 2;

  return Array.from({ length: count }).map((_, index) => ({
    x: x + width / 2,
    y: y + (fromTop ? spacing * (index + 1) + offset : spacing * (count - index) + offset)
  }));
}

export const renderCheckerSprite = (
  texture: any,
  x: number,
  y: number,
  scale: number,
  highlightTexture: any = null
) => {
  return (
    <>
      <Sprite
        texture={texture}
        anchor={[0.5, 0.5]}
        position={[x, y]}
        scale={[scale, scale]}
        roundPixels={true}
      />
      {highlightTexture && (
        <Sprite
          texture={highlightTexture}
          anchor={[0.5, 0.5]}
          position={[x, y]}
          scale={[scale, scale]}
          roundPixels={true}
        />
      )}
    </>
  );
};

export const renderCheckerStack = (
  texture: any,
  area: [number, number, number, number],
  count: number,
  boundsScale: number,
  renderScale: number,
  fromTop: boolean = true,
  isSelected: boolean = false,
  highlightTexture: any = null
) => {
  const positions = getCheckerPositions(area, count, texture.height * boundsScale, fromTop);
  return positions.map((pos, index) => (
    <React.Fragment key={index}>
      {renderCheckerSprite(
        texture,
        pos.x,
        pos.y,
        renderScale,
        isSelected && index == count - 1 ? highlightTexture : null
      )}
    </React.Fragment>
  ));
};
